import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";

function DatenschutzPage() {
  return (
    <>
      <Seo
        path="/datenschutz"
        title="Datenschutzerklärung"
        description="Datenschutzerklärung der Deutsche Bewachung & Sicherheit – Informationen zur Verarbeitung Ihrer Daten gemäß DSGVO."
      />
      <section className="page-hero page-hero--light">
        <div className="container page-hero__content">
          <span className="section-eyebrow">Rechtliches</span>
          <h1>Datenschutzerklärung</h1>
          <p>Informationen über die Verarbeitung Ihrer Daten gemäß DSGVO</p>
        </div>
      </section>

      <section className="section section--light">
        <div className="container legal-content">
          <h2>I. Informationen über die Verarbeitung Ihrer Daten gemäß Art. 13 der Datenschutz-Grundverordnung (DS-GVO)</h2>

          <h3>1. Verantwortlicher und Datenschutzbeauftragter</h3>
          <p>Verantwortlich für diese Website ist:</p>
          <p>
            <strong>Deutsche Bewachung und Sicherheit</strong><br />
            Kugelfangtrift 61a<br />
            30657 Hannover<br />
            E-Mail: info@deutschebunds.de
          </p>
          <p>Den Datenschutzbeauftragten erreichen Sie per E-Mail unter:</p>
          <p>
            datenschutz@deutschebunds.de<br />
            oder über die Adresse:<br />
            Deutsche Bewachung und Sicherheit<br />
            Kugelfangtrift 61a<br />
            30657 Hannover
          </p>

          <h3>2. Daten, die für die Bereitstellung der Website und die Erstellung der Protokolldateien verarbeitet werden</h3>
          <h4>a. Welche Daten werden für welchen Zweck verarbeitet?</h4>
          <p>Bei jedem Zugriff auf Inhalte der Website werden vorübergehend Daten gespeichert, die möglicherweise eine Identifizierung zulassen. Die folgenden Daten werden hierbei erhoben:</p>
          <ul>
            <li>Datum und Uhrzeit des Zugriffs</li>
            <li>IP-Adresse</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Website, von der aus die Website aufgerufen wurde</li>
            <li>Websites, die über die Website aufgerufen werden</li>
            <li>Besuchte Seite auf unserer Website</li>
            <li>Meldung, ob der Abruf erfolgreich war</li>
            <li>Übertragene Datenmenge</li>
            <li>Informationen über den Browsertyp und die verwendete Version</li>
            <li>Betriebssystem</li>
          </ul>
          <p>Die vorübergehende Speicherung der Daten ist für den Ablauf eines Websitebesuchs erforderlich, um eine Auslieferung der Website zu ermöglichen. Eine weitere Speicherung in Protokolldateien erfolgt, um die Funktionsfähigkeit der Website und die Sicherheit der informationstechnischen Systeme sicherzustellen.</p>

          <h4>b. Auf welcher Rechtsgrundlage werden diese Daten verarbeitet?</h4>
          <p>Die Daten werden auf der Grundlage des Art. 6 Abs. 1 Buchstabe f DS-GVO verarbeitet.</p>

          <h4>c. Gibt es neben dem Verantwortlichen weitere Empfänger der personenbezogenen Daten?</h4>
          <p>Die Website wird gehostet. Der Hoster empfängt die oben genannten Daten als Auftragsverarbeiter.</p>

          <h4>d. Wie lange werden die Daten gespeichert?</h4>
          <p>Die Daten werden gelöscht, sobald sie für die Erreichung des Zwecks ihrer Erhebung nicht mehr erforderlich sind. Bei der Bereitstellung der Website ist dies der Fall, wenn die jeweilige Sitzung beendet ist. Die Protokolldateien werden maximal bis zu 24 Stunden direkt und ausschließlich für Administratoren zugänglich aufbewahrt. Danach sind sie nur noch indirekt über die Rekonstruktion von Sicherungsbändern verfügbar und werden nach maximal vier Wochen endgültig gelöscht.</p>

          <h3>3. Betroffenenrechte</h3>
          <h4>a. Recht auf Auskunft</h4>
          <p>Sie können Auskunft nach Art. 15 DS-GVO über Ihre personenbezogenen Daten verlangen, die wir verarbeiten.</p>

          <h4>b. Recht auf Widerspruch</h4>
          <p>Sie haben ein Recht auf Widerspruch aus besonderen Gründen (siehe unter Punkt II).</p>

          <h4>c. Recht auf Berichtigung</h4>
          <p>Sollten die Sie betreffenden Angaben nicht (mehr) zutreffend sein, können Sie nach Art. 16 DS-GVO eine Berichtigung verlangen. Sollten Ihre Daten unvollständig sein, können Sie eine Vervollständigung verlangen.</p>

          <h4>d. Recht auf Löschung</h4>
          <p>Sie können nach Art. 17 DS-GVO die Löschung Ihrer personenbezogenen Daten verlangen.</p>

          <h4>e. Recht auf Einschränkung der Verarbeitung</h4>
          <p>Sie haben nach Art. 18 DS-GVO das Recht, eine Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.</p>

          <h4>f. Recht auf Beschwerde</h4>
          <p>Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen Datenschutzrecht verstößt, haben Sie nach Art. 77 Abs. 1 DS-GVO das Recht, sich bei einer Datenschutzaufsichtsbehörde eigener Wahl zu beschweren.</p>

          <h4>g. Recht auf Datenübertragbarkeit</h4>
          <p>Für den Fall, dass die Voraussetzungen des Art. 20 Abs. 1 DS-GVO vorliegen, steht Ihnen das Recht zu, sich Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an Dritte aushändigen zu lassen.</p>

          <h2>II. Recht auf Widerspruch gemäß Art. 21 Abs. 1 DS-GVO</h2>
          <p>Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Ihrer personenbezogenen Daten, die aufgrund von Artikel 6 Abs. 1 Buchstabe f DS-GVO erfolgt, Widerspruch einzulegen. Der Verantwortliche verarbeitet die personenbezogenen Daten dann nicht mehr, es sei denn, er kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die die Interessen, Rechte und Freiheiten der betroffenen Person überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.</p>
        </div>
      </section>
    </>
  );
}

function ImpressumPage() {
  return (
    <>
      <Seo
        path="/impressum"
        title="Impressum"
        description="Impressum der Deutsche Bewachung und Sicherheit GmbH – Angaben gemäß § 5 TMG und § 18 MStV."
      />
      <section className="page-hero page-hero--light">
        <div className="container page-hero__content">
          <span className="section-eyebrow">Rechtliches</span>
          <h1>Impressum</h1>
          <p>Angaben gemäß § 5 Telemediengesetz (TMG) und § 18 Medienstaatsvertrag (MStV)</p>
        </div>
      </section>

      <section className="section section--light">
        <div className="container legal-content">
          <h3>1. Diensteanbieter</h3>
          <p>
            <strong>Deutsche Bewachung und Sicherheit GmbH</strong><br />
            Kugelfangtrift 61a<br />
            30657 Hannover<br />
            Tel: +49 177 695 7663<br />
            E-Mail: info@deutschebunds.de
          </p>

          <h3>2. Geschäftsführung / Vertretungsberechtigt</h3>
          <p>Gemäß Gesellschaftsvertrag und Handelsregistereintrag</p>

          <h3>3. Registereintragungen</h3>
          <p>
            Handelsregister: Registergericht Hannover<br />
            Gewerbeanmeldung: Gemäß § 34a Gewerbeordnung (GewO)
          </p>
          <p>
            <strong>Zuständige Ordnungsbehörde:</strong><br />
            Öffentlicher Dienst und Behörde in Hannover<br />
            Am Schützenplatz 1<br />
            30169 Hannover
          </p>

          <h3>4. Umsatzsteuer-Identifikationsnummer (USt-IdNr.)</h3>
          <p>Wird auf Anfrage mitgeteilt</p>

          <h3>5. Berufsrechtliche Angaben</h3>
          <p>
            <strong>Tätigkeitsbereich:</strong> Sicherheitsdienstleistungen gemäß § 34a GewO (z.B. Objektschutz, Veranstaltungssicherheit, Personenschutz)<br />
            <strong>Berufshaftpflichtversicherung:</strong> Vorhanden<br />
            <strong>Geltungsbereich:</strong> Bundesrepublik Deutschland
          </p>

          <h3>6. Streitbeilegung</h3>
          <p>Die Europäische Kommission stellt eine Online-Streitbeilegungsplattform (OS-Plattform) bereit: <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">https://ec.europa.eu/consumers/odr</a></p>
          <p>Wir sind bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>

          <h3>7. Haftungshinweise</h3>
          <p><strong>Haftung für Inhalte:</strong> Die Inhalte dieser Website wurden sorgfältig geprüft. Eine Garantie für Vollständigkeit oder Aktualität kann jedoch nicht übernommen werden. Bei rechtlichen Fragen wenden Sie sich bitte direkt an uns.</p>
          <p><strong>Haftung für Links:</strong> Externe Links wurden bei Veröffentlichung auf Rechtsverstöße überprüft. Für Inhalte verlinkter Seiten haften deren Betreiber.</p>
          <p><strong>Urheberrecht:</strong> Texte, Bilder und Grafiken sind urheberrechtlich geschützt. Eine Nutzung bedarf der schriftlichen Zustimmung.</p>

          <h3>8. Berufsaufsichtsbehörde</h3>
          <p>
            Zuständige Aufsichtsbehörde:<br />
            Öffentlicher Dienst und Behörde in Hannover<br />
            Am Schützenplatz 1<br />
            30169 Hannover
          </p>

          <h3>9. Datenschutz</h3>
          <p>Unsere Datenschutzerklärung finden Sie <Link to="/datenschutz">hier</Link>.</p>
          <p><em>Hinweis: Als Sicherheitsunternehmen verarbeiten wir personenbezogene Daten streng nach DSGVO und BDSG.</em></p>

          <h3>10. Bildnachweise</h3>
          <p>Quelle verwendeter Bilder: Eigene Aufnahmen, Unsplash, Pexels</p>
        </div>
      </section>
    </>
  );
}

function AGBPage() {
  return (
    <>
      <Seo
        path="/agb"
        title="Allgemeine Geschäftsbedingungen (AGB)"
        description="Allgemeine Geschäftsbedingungen der Deutsche Bewachung und Sicherheit GmbH für Sicherheitsdienstleistungen."
      />
      <section className="page-hero page-hero--light">
        <div className="container page-hero__content">
          <span className="section-eyebrow">Rechtliches</span>
          <h1>Allgemeine Geschäftsbedingungen</h1>
          <p>AGB für Sicherheitsdienstleistungen</p>
        </div>
      </section>

      <section className="section section--light">
        <div className="container legal-content">
          <h3>§ 1. Allgemeine Dienstausführung</h3>
          <p>(1) Das Wach- und Sicherheitsgewerbe ist gemäß § 34a Gewerbeordnung ein erlaubnispflichtiges Gewerbe und übt seine Sicherheitsdienstleistung als Revierwach-, Separatwach- oder Sonderdienst aus.</p>
          <p>a) Der Revierwachdienst erfolgt in Dienstkleidung durch Einzelstreifen oder Funkstreifenfahrer. Es werden dabei - soweit nichts anderes vereinbart ist - bei jedem Rundgang Kontrollen der in Wachrevieren zusammengefassten Wachobjekte zu möglichst unregelmäßigen Zeiten vorgenommen.</p>
          <p>b) Der Separatwachdienst erfolgt in der Regel durch eine(n) oder mehrere Wachmann/Wachmänner/-frau(en) oder Pförtner/innen, die eigens für ein bzw. wenige in einem räumlichen Zusammenhang stehende Wachobjekte eingesetzt ist/sind. Die einzelnen Tätigkeiten werden in besonderen Dienstanweisungen festgelegt.</p>
          <p>c) Zu den Sonderdiensten gehören z. B. Personalkontrollen, Personenbegleit- und Schutzdienste, Geld- und Werttransporte, der Betrieb von Alarm- und Notrufzentralen (Dienstleistungszentralen) sowie die Durchführung von Kassen-, Ordnungs- und Aufsichtsdiensten für Ausstellungen, Messen, Veranstaltungen und andere Dienste.</p>
          <p>(2) Die gegenseitigen Verpflichtungen von Auftraggeber und Wach- und Sicherheitsunternehmen werden in besonderen Verträgen vereinbart.</p>
          <p>(3) Das Wach- und Sicherheitsunternehmen erbringt seine Tätigkeit als Dienstleistung (keine Arbeitnehmerüberlassung), wobei es sich seines Personals als Erfüllungsgehilfen bedient. Die Auswahl des beschäftigten Personals und das Weisungsrecht liegt - ausgenommen bei Gefahr im Verzuge - bei dem beauftragten Wach- und Sicherheitsunternehmen.</p>
          <p>(4) Es ist zur Erfüllung aller gesetzlichen, behördlichen, sozialrechtlichen und berufsgenossenschaftlichen Verpflichtungen gegenüber seinen Mitarbeitern allein verantwortlich.</p>

          <h3>§ 2. Begehungsvorschrift</h3>
          <p>Im Einzelfall ist für die Ausführung des Dienstes allein die schriftliche Begehungsvorschrift / der Alarmplan maßgebend. Sie enthält den Anweisungen des Auftraggebers entsprechend die näheren Bestimmungen über die Rundgänge, Kontrollen und die sonstigen Dienstverrichtungen, die vorgenommen werden müssen. Änderungen und Ergänzungen der Begehungsvorschrift/des Alarmplanes bedürfen der schriftlichen Vereinbarung.</p>

          <h3>§ 3. Schlüssel und Notfallanschriften</h3>
          <p>(1) Die für den Dienst erforderlichen Schlüssel sind vom Auftraggeber rechtzeitig und kostenlos zur Verfügung zu stellen.</p>
          <p>(2) Für Schlüsselverluste und für vorsätzlich oder fahrlässig durch das Dienstpersonal herbeigeführte Schlüsselbeschädigungen haftet der Unternehmer im Rahmen der Ziffer 10.</p>

          <h3>§ 4. Beanstandungen</h3>
          <p>(1) Beanstandungen jeder Art, die sich auf die Ausführung des Dienstes oder sonstige Unregelmäßigkeiten beziehen, sind unverzüglich nach Feststellung schriftlich der Betriebsleitung des Unternehmens zwecks Abhilfe mitzuteilen.</p>
          <p>(2) Wiederholte oder grobe Verstöße in der Ausführung des Dienstes berechtigen nur dann zur fristlosen Kündigung des Vertrages, wenn der Unternehmer nach schriftlicher Benachrichtigung nicht in angemessener Frist - spätestens innerhalb von sieben Werktagen - für Abhilfe sorgt.</p>

          <h3>§ 5. Auftragsdauer</h3>
          <p>Der Vertrag läuft - soweit nichts Abweichendes schriftlich vereinbart ist - ein Jahr. Wird er nicht drei Monate vor Ablauf der Erstlaufzeit gekündigt, so verlängert sich der Vertrag jeweils um ein weiteres Jahr.</p>

          <h3>§ 6. Ausführung durch andere Unternehmer</h3>
          <p>Der Unternehmer ist berechtigt, in Übereinstimmung mit dem Auftraggeber, sich zur Erfüllung seiner Verpflichtungen gemäß § 34a GewO zugelassener und zuverlässiger Unternehmen zu bedienen.</p>

          <h3>§ 7. Unterbrechung der Bewachung</h3>
          <p>(1) Im Kriegs- oder Streikfalle, bei Unruhen und anderen Fällen höherer Gewalt kann der Unternehmer den Dienst, soweit dessen Ausführung unmöglich wird, unterbrechen oder zweckentsprechend umstellen.</p>
          <p>(2) Im Falle der Unterbrechung ist der Unternehmer verpflichtet, das Entgelt entsprechend den etwa ersparten Löhnen für die Zeit der Unterbrechung zu ermäßigen.</p>

          <h3>§ 8. Vorzeitige Vertragsauflösung</h3>
          <p>(1) Bei Umzug des Auftraggebers sowie bei Verkauf oder sonstiger Aufgabe des Vertragsobjektes kann der Auftraggeber das Vertragsverhältnis mit einer Frist von einem Monat kündigen.</p>
          <p>(2) Gibt der Unternehmer das Revier auf, so ist er ebenfalls zu einer vorzeitigen Lösung des Vertrages unter Einhaltung einer Kündigungsfrist von einem Monat berechtigt.</p>

          <h3>§ 9. Rechtsnachfolge</h3>
          <p>Bei Tod des Auftraggebers tritt der Rechtsnachfolger in den Vertrag ein, es sei denn, dass der Gegenstand des Vertrages hauptsächlich auf persönliche Belange abgestellt war.</p>

          <h3>§ 10. Haftung und Haftungsbegrenzung</h3>
          <p>(1) Die Haftung des Unternehmers für Schäden, die von ihm selbst, seinen gesetzlichen Vertretern oder seinen Erfüllungsgehilfen schuldhaft verursacht werden, ist auf die in Absatz (4) genannten Höchstsummen beschränkt.</p>
          <p>(4) Die Höchstsummen betragen:</p>
          <ul>
            <li>€ 1.000.000 für Personenschäden</li>
            <li>€ 250.000 für Sachschäden</li>
            <li>€ 15.000 für das Abhandenkommen bewachter Sachen</li>
            <li>€ 12.500 für reine Vermögensschäden</li>
          </ul>
          <p>(5) Schadensersatzansprüche müssen innerhalb einer Frist von 4 Wochen geltend gemacht werden.</p>

          <h3>§ 13. Zahlung des Entgelts</h3>
          <p>(1) Das Entgelt für den Vertrag ist, soweit nichts anderes vereinbart ist, monatlich im Voraus zu zahlen.</p>
          <p>(2) Aufrechnung und Zurückbehaltung des Entgelts sind nicht zulässig, es sei denn im Falle einer unbestrittenen oder rechtskräftig festgestellten Forderung.</p>

          <h3>§ 14. Preisänderung</h3>
          <p>Im Falle der Veränderung von Lohnkosten, insbesondere durch den Abschluss neuer Lohn-, Mantel- oder sonstiger Tarifverträge, ist das Entgelt um den Betrag in gleicher Weise zu verändern.</p>

          <h3>§ 15. Vertragsbeginn, Vertragsänderungen</h3>
          <p>(1) Der Vertrag ist für den Unternehmer von dem Zeitpunkt an verbindlich, zu dem dem Auftraggeber die schriftliche Auftragsbestätigung zugeht.</p>
          <p>(2) Nebenabreden, Änderungen, Ergänzungen oder Einschränkungen des Vertrages bedürfen der Schriftform.</p>

          <h3>§ 16. Wettbewerbswidriges Verhalten/Abwerben von Personal</h3>
          <p>Das eingesetzte Personal des Auftragnehmers darf für eine Frist von 12 Monaten nach Beendigung des Vertrages weder für den Auftraggeber noch für durch den Auftraggeber beauftragte dritte Unternehmen beschäftigt werden.</p>

          <h3>§ 17. Gerichtsstand und Erfüllungsort</h3>
          <p>Erfüllungsort und Gerichtsstand ist der Sitz der Betriebsleitung des Unternehmens in Hannover.</p>

          <h3>§ 18. Schlussbestimmung</h3>
          <p>Falls einzelne Bestimmungen dieses Vertrages rechtsunwirksam sein sollten, so sollen sie so umgedeutet werden, dass der mit der ungültigen Bestimmung verbundene wirtschaftliche Zweck erreicht wird. Die Gültigkeit aller übrigen Bestimmungen wird dadurch nicht berührt.</p>
        </div>
      </section>
    </>
  );
}
export { DatenschutzPage, ImpressumPage, AGBPage };
